export const showLoader = () => {
    document.body.classList.add('loader-active')
    const staticLoader = document.getElementById('static-loader')
    if (staticLoader) {
        staticLoader.style.display = 'flex'
    }
}

export const hideLoader = () => {
    document.body.classList.remove('loader-active')
    const staticLoader = document.getElementById('static-loader')
    if (staticLoader) {
        staticLoader.style.display = 'none'
    }
}

export const updateLoaderTheme = theme => {
    const loader = document.querySelector('.customLoader')
    const loaderImage = document.querySelector('.customLoader img')
    if (loader) loader.style.background = theme === 'dark' ? '#101935' : '#FFFFFF'
    if (loaderImage) {
        loaderImage.src = theme === 'dark'
            ? '/img/loader/shieldLoader_dark.gif'
            : '/img/loader/shieldLoader.gif'
        loaderImage.className = theme === 'dark' ? 'shieldDark shield' : 'shieldLight shield'
    }
}
